<template>
  <div class="live-module">
    <v-drop-down-menu
      v-if="$store.state.sceneClassName === 'app'"
      :menu="menu"
      className="app-company-nav"
    ></v-drop-down-menu>
    <div v-else class="nav-footer">
      <div class="nav-footer__content">
        <div class="nav-footer__left">直播产品</div>
        <div class="nav-footer__list">
          <router-link
            to="/live/overview"
            :class="`nav-footer__item ${
              activeRouteName === 'liveOverview'
                ? 'nav-footer__item-selected'
                : ''
            }`"
          >
            概览
          </router-link>
          <router-link
            to="/live/sLive"
            :class="`nav-footer__item ${
              activeRouteName === 'liveSLive' ? 'nav-footer__item-selected' : ''
            }`"
            >直播</router-link
          >
          <router-link
            to="/live/sClass"
            :class="`nav-footer__item ${
              activeRouteName === 'liveSClass'
                ? 'nav-footer__item-selected'
                : ''
            }`"
            >班课</router-link
          >
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import DropDownMenu from '@/components/DropDownMenu';
export default {
  data() {
    return {
      activeRouteName: 'liveOverview',
      menu: [{
        id: 1,
        title: '概览',
        showText: '直播产品',
        link: '/live/overview'
      }, {
        id: 2,
        title: '直播',
        showText: '直播产品',
        link: '/live/sLive'
      }, {
        id: 3,
        title: '班课',
        showText: '直播产品',
        link: '/live/sClass'
      }]
    };
  },
  mounted() {
    this.activeRouteName = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.activeRouteName = to.name;
    }
  },
  components: {
    'v-drop-down-menu': DropDownMenu
  }
};
</script>

<style lang="scss">
.live-module {
  .cooperation-banner {
    padding-top: 254px;
    height: 640px;
    color: #fff;
    background: url('~@/assets/images/live1.jpg') center no-repeat;
    background-size: auto 640px;
  }
  .cooperation-banner .title {
    font-size: 64px;
    font-weight: 600;
  }
  .cooperation-banner .desc {
    margin-top: 24px;
    width: 436px;
    font-size: 20px;
    font-weight: 400;
  }
  .page-middle-part {
    position: relative;
  }
  .page-middle-part .middle-part-bg-img {
    position: absolute;
    left: 0;
    bottom: 407px;
    width: 376px;
    height: 543.36px;
  }
  .page-middle-part .lz-tools-show-area .tools-area-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
    margin-top: 96px;
  }
  .page-middle-part .lz-tools-show-area .tools-area-tips {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
  .page-middle-part .lz-tools-show-area .lz-tools {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 1032px;
    margin-top: 48px;
    margin-bottom: 80px;
  }
  .page-middle-part .lz-tools-show-area .lz-tools .tools-item {
    width: 168px;
    height: 168px;
    background: #fff;
    border-radius: 8px;
    margin: 16px;
    padding: 30px 12px;
  }
  .page-middle-part .lz-tools-show-area .lz-tools .tools-item img {
    width: 64px;
    height: 64px;
  }
  .page-middle-part .lz-tools-show-area .lz-tools .tools-item .image-tips {
    margin-top: 22px;
  }
  .page-middle-part .open-steps-area {
    padding: 96px 0;
    background: #fff;
  }
  .page-middle-part .open-steps-area .open-steps-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
  }
  .page-middle-part .open-steps-area .open-steps-tips {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
  .page-middle-part .open-steps-area .open-steps {
    margin-top: 64px;
  }
  .page-middle-part .open-steps-area .open-steps .step-item {
    width: 368px;
    height: 350px;
    background-color: #fff;
    border-radius: 8px;
    padding: 32px 24px;
    -webkit-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 1;
  }
  .page-middle-part .open-steps-area .open-steps .step-item .step-left-top-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 138px;
    height: 119px;
  }
  .page-middle-part
    .open-steps-area
    .open-steps
    .step-item
    .step-right-bottom-bg {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 188px;
    height: 188px;
  }
  .page-middle-part .open-steps-area .open-steps .step-item .step-btn {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    a {
      font-weight: 500;
      color: #1472ff;
      i {
        font-weight: 700;
      }
    }
  }
  .page-middle-part .open-steps-area .open-steps .step-item .step-btn img {
    margin-left: 8px;
    width: 15px;
  }
  .page-middle-part .open-steps-area .open-steps .step-item .step-title {
    width: 240px;
    height: 33px;
    font-size: 24px;
    font-weight: 500;
    color: #333;
    line-height: 33px;
  }
  .page-middle-part .open-steps-area .open-steps .step-item .step-content {
    width: 320px;
    height: 62px;
    font-size: 20px;
    font-weight: 400;
    color: #666;
    line-height: 32px;
    margin-top: 17px;
    margin-bottom: 24px;
  }
  .page-middle-part .open-steps-area .open-steps .step2 {
    margin: 0 32px;
  }
  .lz-live-advance-info {
    padding: 96px 0;
    background: rgba(20, 114, 255, 0.04);
  }
  .lz-live-advance-info .advance-info-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
  }
  .lz-live-advance-info .advance-info-tips {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
  .lz-live-advance-info .advance-infos {
    width: 1200px;
    margin-top: 64px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .lz-live-advance-info .advance-infos .advance-info-item {
    margin: 16px;
    padding: 24px;
    width: 568px;
    height: 350px;
    background-color: #fff;
    -webkit-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    position: relative;
    z-index: 1;
  }
  .lz-live-advance-info .advance-infos .advance-info-item .item-left-top-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 250px;
    height: 244px;
  }
  .lz-live-advance-info
    .advance-infos
    .advance-info-item
    .item-right-bottom-bg {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 330px;
    height: 206px;
  }
  .lz-live-advance-info .advance-infos .advance-info-item .info-item-title {
    width: 332px;
    height: 33px;
    font-size: 24px;
    font-weight: 500;
    color: #333;
    line-height: 33px;
    text-shadow: 0 10px 20px rgba(0, 0, 0, 0.04);
  }
  .lz-live-advance-info .advance-infos .advance-info-item .info-item-content {
    width: 384px;
    height: 128px;
    font-size: 20px;
    font-weight: 400;
    color: #666;
    line-height: 32px;
    text-shadow: 0 10px 20px rgba(0, 0, 0, 0.04);
    margin-top: 16px;
  }
  .famous-user-info {
    position: relative;
    z-index: 2;
    padding: 96px 0;
    background-color: #fff;
  }
  .famous-user-info .famous-user-info-bt-img {
    position: absolute;
    width: 322px;
    height: 520px;
    right: 0;
    bottom: 569px;
    z-index: 1;
  }
  .famous-user-info .famous-user-info-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
  }
  .famous-user-info .famous-user-info-tips {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
  }
  .famous-user-info .famous-user-list {
    width: 1168px;
    background: #fff;
    border-radius: 12px;
  }
  .famous-user-info .famous-user-list .famous-users {
    width: 1200px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .famous-user-info .famous-user-list .famous-users .famous-user {
    width: 168px;
    height: 168px;
    background: #fff;
    -webkit-box-shadow: 0 10px 30px 0 rgba(102, 102, 102, 0.08);
    box-shadow: 0 10px 30px 0 rgba(102, 102, 102, 0.08);
    border-radius: 8px;
    margin: 16px;
  }
  .famous-user-info .famous-user-list .famous-users .famous-user .user-name {
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    text-shadow: 0 10px 30px rgba(102, 102, 102, 0.08);
    text-align: center;
  }
  .famous-user-info .famous-user-list .famous-users .famous-user img {
    width: 168px;
  }
  .famous-user-info .user-demo-area {
    margin-top: 80px;
    width: 1168px;
    background: rgba(20, 114, 255, 0.04);
    border-radius: 12px;
    padding: 48px;
    position: relative;
    z-index: 1;
  }
  .famous-user-info .user-demo-area .demo-area-left-bottom-bg-img {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
  .famous-user-info .user-demo-area .demo-area-right-top-bg-img {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }
  .famous-user-info .user-demo-area .user-demo-img {
    width: 520px;
    height: 302px;
    margin-right: 32px;
    position: relative;
    z-index: 3;
  }
  .famous-user-info .user-demo-area .user-demo-describe .user-demo-tips {
    width: 500px;
    height: 34px;
    font-size: 24px;
    font-weight: 500;
    color: #333;
  }
  .famous-user-info
    .user-demo-area
    .user-demo-describe
    .user-demo-describe-content {
    width: 500px;
    height: 80px;
    font-size: 20px;
    font-weight: 400;
    color: #333;
    margin-top: 16px;
  }
  .famous-user-info .user-demo-area .user-demo-describe .user-use-tools {
    margin-top: 40px;
  }
  .famous-user-info
    .user-demo-area
    .user-demo-describe
    .user-use-tools
    .tools-tips {
    width: 162px;
    height: 25px;
    font-size: 18px;
    font-weight: 400;
    color: #333;
  }
  .famous-user-info
    .user-demo-area
    .user-demo-describe
    .user-use-tools
    .tools-list {
    margin-top: 16px;
  }
  .famous-user-info
    .user-demo-area
    .user-demo-describe
    .user-use-tools
    .tools-list
    .tools-item {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #1472ff;
    font-size: 16px;
    font-weight: 400;
    color: #1472ff;
    text-align: center;
    background-color: rgba(255, 255, 255, 0);
    margin: 0 6px;
  }
  .famous-user-info
    .user-demo-area
    .user-demo-describe
    .user-use-tools
    .demo-user-name {
    margin-top: 30px;
    width: 176px;
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    line-height: 22px;
  }
  .create-store-entrance-area {
    padding: 56px 0;
    background: #1472ff;
  }
  .create-store-entrance-area .entrance-tips {
    width: 448px;
    height: 36px;
    font-size: 28px;
    font-weight: 500;
    color: #fff;
  }
  .create-store-entrance-area .create-store-btn {
    margin-top: 32px;
    width: 160px;
    height: 44px;
    border-radius: 32px;
    border: 1px solid #fff;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    line-height: 44px;
    text-align: center;
  }
  .create-store-entrance-area,
  .describe-area,
  .describe-area .swiper-container .swiper-slide .describe-content,
  .display-flex-column-center,
  .famous-user-info,
  .page-middle-part .open-steps-area,
  .page-middle-part .lz-tools-show-area,
  .page-middle-part .lz-tools-show-area .lz-tools .tools-item,
  .lz-live-advance-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .describe-area .swiper-container .swiper-pagination,
  .display-flex-row-center,
  .famous-user-info .famous-user-list .famous-users,
  .famous-user-info .user-demo-area,
  .page-middle-part .open-steps-area .open-steps,
  .page-middle-part .lz-tools-show-area .lz-tools,
  .lz-live-advance-info .advance-infos {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .live-sLive,
  .live-sClass {
    .lz-live-functional-introduce .live-functional-info,
    .lz-live-functional-introduce .live-functional-info .live-introduce-detail {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
    .display-flex-column-center,
    .open-steps-area,
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .introduce-text,
    .lz-live-functional-introduce
      .live-functional-info
      .live-introduce-detail
      .introduce-text {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .cooperation-banner {
      padding-top: 228px;
      height: 640px;
      color: #fff;
      background-color: #1472ff;
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 640px;
    }
    .cooperation-banner .title {
      width: 256px;
      height: 72px;
      font-size: 64px;
      font-weight: 600;
      color: #fff;
    }
    .cooperation-banner .desc {
      margin-top: 24px;
      width: 400px;
      font-size: 20px;
      font-weight: 400;
      color: #fff;
    }
    .cooperation-banner .proxyBtn {
      width: 168px;
      background: #fff;
      border-radius: 22px;
      font-size: 14px;
      font-weight: 500;
      color: #1472ff;
      line-height: 44px;
      display: inline-block;
      text-align: center;
      margin-top: 80px;
    }
    .cooperation-banner .proxyBtn:hover {
      background: #3d91ff;
      color: #fff;
    }
    .cooperation-banner .proxyBtn:active {
      background: #1159d6;
      color: #fff;
    }
    .open-steps-area {
      padding: 96px 0;
      margin-top: -24px;
      background-color: rgba(20, 114, 255, 0.04);
    }
    .open-steps-area .open-steps-title {
      height: 44px;
      font-size: 36px;
      font-weight: 500;
      color: #333;
      line-height: 44px;
      text-align: center;
    }
    .open-steps-area .open-steps {
      margin-top: 64px;
      margin-left: -32px;
    }
    .open-steps-area .open-steps .step-item {
      margin: 0 32px 0 16px;
      width: 268px;
      height: 236px;
      background-color: #fff;
      -webkit-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      padding: 32px 24px;
      position: relative;
      z-index: 1;
    }
    .open-steps-area .open-steps .step-item .step-left-top-bg {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 124px;
      height: 94px;
    }
    .open-steps-area .open-steps .step-item .step-right-bottom-bg {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 2;
      width: 142px;
      height: 144px;
    }
    .open-steps-area .open-steps .step-item .step-title {
      width: 120px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      line-height: 28px;
      text-shadow: 0 10px 20px rgba(0, 0, 0, 0.04);
    }
    .open-steps-area .open-steps .step-item .step-content {
      margin-top: 8px;
      width: 220px;
      height: 48px;
      font-size: 16px;
      font-weight: 400;
      color: #666;
      line-height: 24px;
      text-shadow: 0 10px 20px rgba(0, 0, 0, 0.04);
    }
    .open-steps-area .open-steps .step1 {
      margin-left: 0;
    }
    .open-steps-area .open-steps .step4 {
      margin-right: 0;
    }
    .live-introduce-detail {
      padding: 96px 0;
      position: relative;
    }
    .live-introduce-detail .introduce-text {
      width: 468px;
    }
    .live-introduce-detail .introduce-text .create-store-entrance-area {
      padding: 56px 0;
      background: #1472ff;
    }
    .lz-classroom-functional-introduce .gray-bg-color,
    .lz-live-functional-introduce .gray-bg-color {
      background: rgba(20, 114, 255, 0.04);
    }
    .live-introduce-detail .introduce-text .introduce-img0,
    .live-introduce-detail .introduce-text .introduce-img1,
    .live-introduce-detail .introduce-text .introduce-img2,
    .live-introduce-detail .introduce-text .introduce-img3 {
      width: 668px;
    }
    .live-introduce-detail .introduce-text .live-bg-img0 {
      width: 212px;
      height: 446px;
      position: absolute;
      left: 0;
      top: 195px;
    }
    .live-introduce-detail .introduce-text .live-bg-img4 {
      width: 210px;
      height: 406px;
      position: absolute;
      top: 228px;
      right: 0;
    }
    .lz-classroom-functional-introduce {
      padding-top: 137px;
    }
    .lz-classroom-functional-introduce .classroom-introduce-detail {
      padding: 20.5px 0;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .introduce-text {
      width: 468px;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .introduce-text
      .introduce-title {
      width: 100%;
      height: 44px;
      font-size: 36px;
      font-weight: 500;
      color: #333;
      line-height: 44px;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .introduce-text
      .introduce-tips {
      font-size: 16px;
      font-weight: 400;
      color: #333;
      margin-top: 24px;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .image-wrapper {
      position: relative;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .image-wrapper
      .introduce-bg-img {
      width: 610px;
      position: absolute;
      z-index: -1;
      top: 0;
      margin-top: -96px;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .image-wrapper
      .position-left {
      margin-left: -208px;
      left: 0;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .image-wrapper
      .position-right {
      margin-right: -208px;
      right: 0;
    }
    .lz-classroom-functional-introduce
      .classroom-introduce-detail
      .image-wrapper
      .introduce-img {
      width: 668px;
    }
    .lz-live-functional-introduce .live-functional-info {
      position: relative;
      margin: 0 auto;
      padding: 48px 0;
    }
    .lz-live-functional-introduce .live-functional-info .text-in-left-style {
      margin-right: 32px;
    }
    .lz-live-functional-introduce .live-functional-info .text-in-right-style {
      margin-left: 32px;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }
    .lz-live-functional-introduce .live-functional-info .live-introduce-detail {
      position: relative;
      padding: 48px 0;
    }
    .lz-live-functional-introduce
      .live-functional-info
      .live-introduce-detail
      .introduce-text {
      width: 468px;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
    .lz-live-functional-introduce
      .live-functional-info
      .live-introduce-detail
      .introduce-text
      .introduce-title {
      width: 468px;
      height: 88px;
      font-size: 36px;
      font-weight: 500;
      color: #333;
      line-height: 44px;
    }
    .lz-live-functional-introduce
      .live-functional-info
      .live-introduce-detail
      .introduce-text
      .introduce-tips {
      width: 468px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #353535;
      margin-top: 24px;
    }
    .lz-live-functional-introduce
      .live-functional-info
      .live-introduce-detail
      .introduce-img {
      width: 668px;
    }
    .lz-live-functional-introduce .live-functional-info .live-bg-img0 {
      width: 212px;
      height: 446px;
      position: absolute;
      left: 0;
      top: 195px;
    }
    .lz-live-functional-introduce .live-functional-info .live-bg-img4 {
      width: 210px;
      height: 406px;
      position: absolute;
      right: 0;
      top: 228px;
    }
    .display-flex-row-center,
    .live-introduce-detail,
    .open-steps-area .open-steps,
    .lz-classroom-functional-introduce .classroom-introduce-detail,
    .lz-live-functional-introduce .live-functional-info,
    .lz-live-functional-introduce .live-functional-info .live-introduce-detail {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }

    .lz-classroom-functional-introduce .text-in-left-style {
      margin-right: 52px;
    }
    .lz-classroom-functional-introduce .text-in-right-style {
      margin-left: 52px;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
      flex-direction: row-reverse;
    }
  }
}
.app .live-module {
  padding-top: 1.04rem;
  .app-company-nav {
    position: fixed;
    top: 1.04rem;
    left: 0;
    width: 100%;
    z-index: 8;
  }
  .cooperation-banner {
    width: 100%;
    height: 8.64rem;
    background: url('~@/assets/images/live1_app.png') center no-repeat;
    background-size: 100%;
    background-position-y: -0.96rem;
    padding: 2.2rem 0.32rem;
    text-align: center;
    .title {
      font-size: 0.8rem;
    }
    .desc {
      width: auto;
      margin-top: 0.32rem;
      font-size: 0.28rem;
    }
  }
  .describe-area-app {
    text-align: center;
    color: #333;
    .d-item {
      padding: 1.28rem 0.32rem;
      .i-title {
        font-weight: 500;
        line-height: 0.72rem;
        font-size: 0.56rem;
      }
      .i-subtitle {
        font-weight: 400;
        line-height: 0.44rem;
        font-size: 0.28rem;
        margin-top: 0.32rem;
        letter-spacing: -0.006rem;
        height: 1.76rem;
        color: #999;
      }
      .live-img {
        max-width: 100%;
        margin-top: 0.96rem;
      }
      &:nth-of-type(even) {
        background: rgba(20, 114, 255, 0.04);
      }
    }
  }
  .page-middle-part {
    .lz-tools-show-area {
      text-align: center;
      padding-bottom: 1.28rem;
      .tools-area-title {
        font-weight: 500;
        line-height: 0.72rem;
        font-size: 0.56rem;
        margin-top: 1.28rem;
        padding: 0 0.32rem;
      }
      .tools-area-tips {
        font-weight: 400;
        line-height: 0.44rem;
        font-size: 0.28rem;
        margin-top: 0.32rem;
        letter-spacing: -0.006rem;
        height: 1.76rem;
        padding: 0 0.32rem;
      }
    }
    .lz-tools {
      margin: 0;
      .tools-item {
        width: 20%;
        height: auto;
        margin: 0 0 0.22rem;
        padding: 0;
        img {
          margin-bottom: 0.22rem;
          width: 0.64rem;
          height: auto;
        }
        .image-tips {
          margin-top: 0;
          font-size: 0.18rem;
        }
      }
    }
    .open-steps-area {
      display: block;
      padding: 1.28rem 0.32rem;
      background: rgba(20, 114, 255, 0.04);
      text-align: center;
      .open-steps-title {
        font-weight: 500;
        line-height: 0.72rem;
        font-size: 0.56rem;
      }
      .open-steps-tips {
        font-weight: 400;
        line-height: 0.44rem;
        font-size: 0.28rem;
        margin-top: 0.32rem;
        letter-spacing: -0.006rem;
        height: 1.76rem;
      }
      .open-steps {
        margin-top: -0.32rem;
        display: block;
        .step-item {
          width: 100%;
          position: relative;
          margin-bottom: 0.32rem;
          margin-left: 0;
          padding: 0.48rem 0.32rem;
          height: 3.54rem;
          background: #fff;
          box-shadow: 0 10px 30px 0 rgba(102, 102, 102, 0.08);
          border-radius: 4px;
          .step-title {
            width: auto;
            height: auto;
            font-weight: 500;
            line-height: 0.5rem;
            font-size: 0.36rem;
          }
          .step-content {
            margin-top: 0.32rem;
            line-height: 0.4rem;
            font-size: 0.28rem;
            text-align: left;
            width: auto;
            height: auto;
          }
          .step-btn {
            display: block;
            text-align: center;
            line-height: 0.48rem;
            font-weight: 500;
            font-size: 0.28rem;
          }
          .step-left-top-bg {
            width: 2rem;
            height: auto;
          }
          .step-right-bottom-bg {
            width: 2.48rem;
            height: auto;
          }
        }
      }
    }
  }
  .live-sLive,
  .live-sClass {
    .cooperation-banner {
      padding: 1.2rem 0 0;
      .title {
        width: auto;
        height: auto;
        margin-bottom: 0.32rem;
        font-size: 0.8rem;
        line-height: 0.96rem;
      }
      .desc {
        margin: 0 0 0.48rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
      }
      .proxyBtn {
        display: inline-block;
        width: 3.52rem;
        height: 0.8rem;
        margin: 0;
        line-height: 0.8rem;
        background-color: #fff;
        border-radius: 0.88rem;
        color: #1472ff;
        text-align: center;
        font-size: 0.32rem;
      }
    }
    .lz-live-functional-introduce {
      .live-functional-info,
      .live-introduce-detail {
        display: block;
      }
      .live-functional-info {
        padding: 1.28rem 0.32rem;
      }
      .live-introduce-detail {
        padding: 0;
        margin: 0;
        .introduce-text {
          display: block;
          width: 100%;
          .introduce-title {
            width: auto;
            height: auto;
            margin-bottom: 0.32rem;
            font-size: 0.56rem;
            font-weight: 500;
            line-height: 0.72rem;
          }
          .introduce-tips {
            width: auto;
            margin: 0 0 0.96rem;
            font-size: 0.28rem;
            line-height: 0.44rem;
          }
        }
        .introduce-img {
          width: 100%;
        }
      }
    }
  }
  .live-sClass {
    .open-steps-area {
      background: #ffffff;
      display: block;
      margin: 0;
      padding: 1.28rem 0.32rem;
      .open-steps-title {
        margin: 0 0 0.96rem;
        font-size: 0.56rem;
        font-weight: 500;
        line-height: 0.72rem;
        text-align: left;
      }
    }
    .open-steps {
      margin: 0;
      display: block;
      .step-item {
        box-shadow: 0 10px 30px 0 rgba(102, 102, 102, 0.08);
        padding: 0.48rem 0.32rem;
        margin: 0 0 0.32rem;
        width: 100%;
        height: 2.74rem;
        border-radius: 0.08rem;
        background-size: 100%;
        position: relative;
        .step-left-top-bg {
          width: 2rem;
          height: 1.6rem;
        }
        .step-right-bottom-bg {
          width: 2rem;
          height: auto;
        }
        .step-title {
          width: auto;
          height: auto;
          margin-bottom: 0.32rem;
          font-size: 0.36rem;
          font-weight: 500;
          line-height: 0.5rem;
          text-align: center;
        }
        .step-content {
          width: auto;
          height: auto;
          color: #666;
          line-height: 0.4rem;
          font-size: 0.28rem;
          text-align: left;
        }
      }
    }
    .lz-classroom-functional-introduce {
      padding: 0;
      .classroom-introduce-detail {
        margin: 0;
        padding: 1.28rem 0.32rem;
        display: block;
        &:nth-of-type(odd) {
          background-color: #f4f9ff;
        }
        .introduce-text {
          width: 100%;
          .introduce-title {
            margin: 0 0 0.32rem;
            font-size: 0.56rem;
            font-weight: 500;
            line-height: 0.72rem;
            text-align: left;
          }
          .introduce-tips {
            margin: 0 0 0.96rem;
            font-size: 0.28rem;
            line-height: 0.44rem;
            text-align: left;
          }
        }
        .introduce-bg-img {
          display: none;
        }
        .image-wrapper .introduce-img {
          width: 100%;
        }
      }
    }
  }
}
</style>
